module.exports = __webpack_public_path__ + "img/aboutUs.56642089.png";